import { motion, useInView } from "framer-motion";
import { useRef } from "react";

interface Slider_PanelProps {
    title: string;
    subtitle: string;
    contexts: string[];
}
const Slider_Panel: React.FC<Slider_PanelProps> = ({ title, subtitle, contexts }) => {

    const Ref = useRef(null);
    const InView = useInView(Ref, { once: false, amount: 0.2 });
    return (
        <motion.div
            ref={Ref}
            initial="hidden"
            animate={InView ? "visible" : "hidden"}
            variants={{
                hidden: { opacity: 0, y: 10 },
                visible: { opacity: 1, y: 0, transition: { duration: 2, type: "spring", bounce: 0 } },
            }}
            className="contain w-full h-auto bg-white flex flex-col items-start justify-center  gap-4 pl-[25px] pr-[10px] pt-[35px] z-10 rounded-[26px] py-16">
            <div className="border-l-2 border-[#172B6B] px-2 text-[#172B6B] font-bold text-[20px] font-bungeeinline ">{title}</div>
            <div className="font-bold text-[#F8D835] font-bungeeinline text-xl sm:text-3xl uppercase ">{subtitle}</div>
            {contexts.map((context, index) => (
                <div key={index} className="text-lg sm:text-xl">
                    {context}
                </div>
            ))}
        </motion.div>
    );
};
export default Slider_Panel;
